import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { DeleteMessagePayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useDeleteMessage = () => {
  const { removeMessage } = useConversationQueryCache();
  const { messages } = useSlingApi();

  const mutation = useMutation({
    mutationFn: (payload: DeleteMessagePayload) => messages.delete(payload),
    onSuccess: (message, payload) => {
      removeMessage(payload.conversationId, payload.messageId);
    },
  });

  return mutation;
};
